module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBoldItalic.fc17ea62.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/OpenSans-SemiBoldItalic.ttf
// module id = 3178
// module chunks = 51